import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OktaAuthService } from '@common_libraries/Services/login/oktaAuth.service';
import { ModuleAuth } from '@common_libraries/lib/ModuleAuth';
import { TRASecurityModule } from '@common_libraries/lib/Enums';
import { SessionService } from '@services/session/session.service';
import { LogoutReasons } from '@common_libraries/lib/Enums';
import { Observable, Subject } from 'rxjs';
import { resolve } from 'dns';

@Injectable()
export class OktaAuthGuard  {
  readyObservable = new Observable();

  constructor(
    private okta: OktaAuthService,
    private oktaService: OktaAuthService,
    private router: Router,
    private moduleAuth: ModuleAuth,
    private sessionService: SessionService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> | boolean {
    if (!this.moduleAuth.UserHasModuldeAuthData()) {
      this.SetIsLoggedOut();
      window.location.href = '/login';
      return false;
    }

    if (!this.moduleAuth.IsUserAuthed(TRASecurityModule.Default)) {
      this.SetIsLoggedOut();
      window.location.href = '/login';
      return false;
    }

    return this.okta.isAuthenticated(state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

  private SetIsLoggedOut() {
    this.sessionService.SetIsLoggedIn(false);
  }
}
